<div>
  <mat-dialog-content class="header px-1 py-2">
    <h2 class="text-center">IMPORTANT</h2>
  </mat-dialog-content>
  <div mat-dialog-content>
    <p> You or a Youth related to your account have Show Entry payments due that require your attention.</p>

    <p class="instruction">1. Please select the show:</p>
    <mat-selection-list class="full-width" (selectionChange)="onSelectionChanged($event)" [multiple]="false">
      @for(option of uniqueShows(); track option.showId) {
        <mat-list-option [value]="option">
          {{option.showName}} [{{option.showId}}]
        </mat-list-option>
      }
    </mat-selection-list>

    @if(ridersEntries().length) {
      <p class="instruction">2. Please select the riders:</p>
  
      <table>
        <tr>
          <th class="min-width-150">Rider Name</th>
          <th class="min-width-150">Class Code</th>
          <th class="min-width-150">Action</th>
        </tr>
  
        @for(line of ridersEntries(); track line.id) {
          <tr>
            <td>{{line.riderName}}</td>
            <td>{{line.classCode}}</td>
            <td>
              <button
                (click)="addToOrders(line.orderId)"
                mat-flat-button
                color="primary"
              >Add to cart</button>
            </td>
          </tr>
        }
      </table>
    }

    @if(entriesSelected().length) {
      <div class="payment-border">
        <div class="payment-header">
          Entries Cart
        </div>

        <p class="explain-text">Your entries selected for payment:</p>
        <table>
          <tr>
            <th class="min-width-150">Rider Name</th>
            <th class="min-width-150">Class Code</th>
            <th class="min-width-150">Show ID</th>
            <th class="min-width-150">Action</th>
          </tr>
    
          @for(line of entriesSelected(); track line.id) {
            <tr>
              <td>{{line.riderName}}</td>
              <td>{{line.classCode}}</td>
              <td>{{line.showId}}</td>
              <td>
                <button
                  (click)="removeOrder(line.orderId)"
                  mat-raised-button
                >Remove from cart</button>
              </td>
            </tr>
          }
        </table>
  
        <button mat-raised-button class="action-btn" (click)="payEntries()" color="primary">Pay selected entries</button>
      </div>
    }
  </div>
</div>